import { Collapse, Grid, Paper } from "@mui/material";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DailyNameTime from "./DailyNameTime";
import DailySummaryInfo from "./DailySummaryInfo";
import DailySummaryTable from "./DailySummaryTable";

export default function DailySummary({
  data = [],
  dayName = "",
  pies = [],
  blackoutDates = false,
  ...props
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="my-2">
      <Paper className={`p-5 ${blackoutDates && "bg-bright-gray"}`}>
        <Grid container alignItems="stretch">
          <Grid
            item
            lg={3}
            md={3}
            sm={4}
            xs={12}
            className="border-r border-white-gray"
          >
            <DailyNameTime
              dayName={dayName}
              weekDay={props?.weekDay ?? ""}
              onClick={() => setOpen((prev) => !prev)}
              // onClick={() => setOpen((prev) => (blackoutDates ? false : !prev))}
            />
          </Grid>
          <Grid item flexGrow={1}>
            <DailySummaryInfo summary={data} />
          </Grid>
        </Grid>
      </Paper>
      <Collapse in={open} unmountOnExit>
        <DailySummaryTable
          data={data}
          exportType="day"
          dateType={props.weekDay}
          pies={pies}
          onCloseSummary={() => setOpen(false)}
          {...props}
        />
      </Collapse>
    </div>
  );
}
